<template>
  <div class="dispositions">
    <span class="dispositions__label">{{ label }}</span>
    <div class="dispositions__wrapper">
      <button
        v-for="disposition in dispositions"
        :key="disposition.value"
        :aria-label="$t('general.cta.changeCardView')"
        @click="changeDisposition(disposition.value)"
        :class="[
          'dispositions__wrapper__button',
          { disable: $route.query.disposition !== disposition.value },
        ]"
      >
        <icon
          :data="pageIcons[disposition.value]"
          class="dispositions__wrapper__button__icon"
          width="1.875rem"
          height="1.25rem"
          original
        ></icon>
      </button>
    </div>
  </div>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import { pageIcons } from "../../../plugins/page-icons";

const router = useRouter();
const route = useRoute();

defineProps({
  dispositions: Array,
  label: String,
});

const changeDisposition = (value) => {
  if (route.query.disposition === value) {
    return;
  }
  return router.push({
    name: "home",
    query: { ...route.query, disposition: value },
  });
};
</script>

<style lang="scss" scoped>
.dispositions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;

  &__label {
    @include label-filter;
    margin-right: toRem(10);
  }

  &__wrapper {
    display: flex;
    &__button {
      border: 1px solid $scala-grigi-gray-3;
      height: toRem(30);
      width: toRem(48);
      border-radius: toRem(50) 0px 0px toRem(50);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      &:last-child {
        border-radius: 0px toRem(50) toRem(50) 0px;
      }

      &.disable {
        border-color: $scala-grigi-gray-2;
        opacity: 0.3;
        ::v-deep .dispositions__button__icon {
          fill: $scala-grigi-gray-3 !important;
        }
      }

      &:hover:is(.disable) {
        opacity: 1;
        border-color: $primary-yellow;
        @include chip-bottom-timeline;
      }
    }
  }
}
</style>
